import {BusinessLayout} from "../../layouts/Business";
import {Banner} from "../../components/business/main/Banner";
import {Content1} from "../../components/business/main/Content1";
import {Content2} from "../../components/business/main/Content2";
import {Content3} from "../../components/business/main/Content3";
import {Content4} from "../../components/business/main/Content4";
import {Content5} from "../../components/business/main/Content5";
import {Content6} from "../../components/business/main/Content6";
import {Content7} from "../../components/business/main/Content7";
import {Content8} from "../../components/business/main/Content8";
import {Content9} from "../../components/business/main/Content9";
import {Content10} from "../../components/business/main/Content10";
import {Content11} from "../../components/business/main/Content11";
import {Content12} from "../../components/business/main/Content12";
import {Content13} from "../../components/business/main/Content13";
import {Content14} from "../../components/business/main/Content14";
import {Content15} from "../../components/business/main/Content15";


export const BusinessPage = () => {
    return (
        <BusinessLayout>
            <Banner/>
            <Content1/>
            <Content2/>
            <Content3/>
            <Content4/>
            <Content5/>
            <Content6/>
            <Content7/>
            <Content8/>
            <Content9/>
            <Content10/>
            <Content11/>
            <Content12/>
            <Content13/>
            <Content14/>
            <Content15/>
        </BusinessLayout>
    );
}